

export class PageResponse{
  constructor(
    public content?: any,
    public first?: boolean,
    public last?: boolean,
    public number?: number,
    public numberOfElements?: number,
    public pageable?: Pageable,
    public size?: number,
    public sort?: Sort,
    public totalElements?: number,
    public totalPages?: number,
  ){
  }
}

export class Pageable{
  constructor(
    public offset?: number,
    public pageNumber?: number,
    public pageSize?: number,
    public paged?: boolean,
    public sort?: Sort,
    public unPaged?: boolean,
  ){
  }
}

export class Sort{
  constructor(
    public sorted?: boolean,
    public unSorted?: boolean,
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/page.model.ts